import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const getCaseStudies = async () => {
  try {
    const { data } = await axiosInstance.get("/CaseStudies");
    return data || null;
  } catch (error) {
    console.error("Error fetching case studies:", error);
    return null;
  }
};

const useCaseStudies = () => {
  return useQuery({
    queryKey: ["caseStudies"],
    queryFn: getCaseStudies,
    keepPreviousData: true,
  });
};

export default useCaseStudies;

